if(!customElements.get('product-review-rating')) {
    class ProductReviewRating extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.selectors = {
                rating: this.querySelector("#custom-rating")
            }
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if(mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                        const elementToMove = this.selectors.rating.querySelector('.inlineRating__number');
                        const elementParentTarget = this.selectors.rating.querySelector('.inlineRating__text');
                        const elementChildTarget = this.selectors.rating.querySelector('.RatingStatistics__text');
                        elementParentTarget && elementParentTarget.insertBefore(elementToMove, elementChildTarget);
                        const reviewCount = elementChildTarget.querySelector('.rio-strong').innerText;
                        elementChildTarget && (elementChildTarget.innerHTML = '');
                        const reviewCountNumber = parseInt(reviewCount.replace(/,/g, ''), 10);
                        const reviewCountFormatted = reviewCountNumber.toLocaleString('en-US');
                        elementChildTarget && (elementChildTarget.innerText = `(${reviewCountFormatted} Reviews)`);
                    }
                }
            })
            observer.observe(this.selectors.rating, {childList: true});
        }
    }
    customElements.define('product-review-rating', ProductReviewRating);
}